import SvgIcon from "@mui/material/SvgIcon";

interface OpenDrawerIconProps {
  children?: React.ReactNode;
  color?: string;
  fontSize?: number | string;
}

/**
 * Shows the sidebar.
 *
 * A panel outline on the same 24px grid and stroke weight as the rest of the
 * icon set. The previous glyph packed a panel, three list rules and an arrow
 * into roughly twenty pixels, which read as noise at this size.
 */
const OpenDrawerIcon: React.FC<OpenDrawerIconProps> = (props) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        fontSize: props.fontSize,
        color: props.color,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 1.7,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    >
      <rect x="3" y="4" width="18" height="16" rx="2.5" />
      <path d="M9.5 4v16" />
    </SvgIcon>
  );
};

export default OpenDrawerIcon;
